/*
* Flatline Agency Theme
*
* Use this file to add custom Javascript to Flatline Agency.  Keeping your custom
* Javascript in this fill will make it easier to update Flatline Agency. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // Close size chart drawer on mobile close button
  document.addEventListener('click', function(event) {
    var closeButton = event.target.closest('[data-drawer-mobile-close]');
    if (!closeButton) return;

    var popupChart = closeButton.closest('.popup-chart');
    if (!popupChart) return;

    var drawer = document.querySelector('.product__popup.size-variant-dropdown');

    // console.clear();
    // console.log('popupChart', popupChart);
    // console.log('closeButton', closeButton);
    
    popupChart.classList.remove('is-open');
    popupChart.removeAttribute('tabindex');
    setTimeout(function() {
      popupChart.classList.add('cv-h');
        document.querySelector('body').classList.add('js-drawer-open');
        drawer.classList.remove('cv-h');
        drawer.classList.add('is-open');
        drawer.setAttribute('tabindex', -1);
    }, 300);
  });

  document.addEventListener('click', function(event) {
    var openButton = event.target.closest('.product__popup .product__popup__link.test1');
    if (!openButton) return;

    var drawer2 = document.querySelector('.product__popup.size-variant-dropdown');

    drawer2.classList.remove('is-open');
    drawer2.removeAttribute('tabindex');
    setTimeout(function() {
      drawer2.classList.add('cv-h');
    }, 300);
  });





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
